import {Component, Input} from '@angular/core';
import {BaseSwiperCardComponent} from '../base-swiper-card.component';
import {SwiperItem} from '../models/swiper-item.models';

@Component({
  selector: 'app-swiper-card',
  templateUrl: './swiper-card.component.html',
  styleUrls: ['../swiper.scss']
})

export class SwiperCardComponent extends BaseSwiperCardComponent {
  @Input() swiperItems: Array<SwiperItem>;
}
